import { useVectorCapitalSimulator } from '../VectorCapitalSimulatorContext';

export default function VcMonthlyReturnsWidget() {
  const sim = useVectorCapitalSimulator();
  return sim.renderMonthlyReturns();
}
